import { useEffect } from 'react';
import { Layout, LayoutProps } from 'react-admin';
import { useLocation } from 'react-router-dom';
import { AppErrorBoundary } from '../components/common/AppErrorBoundary/AppErrorBoundary';
import { SessionExpirationGuard } from '../components/common/SessionExpirationGuard/SessionExpirationGuard';
import { PhoneCallsProvider } from '../contexts/PhoneCallsContext/PhoneCallsContext';
import MixpanelService from '../services/mixpanel';
import { CustomAppBar } from './CustomAppBar';
import { CustomMenu } from './CustomMenu';

const LayoutWithModals: React.FC<LayoutProps> = (props) => {
  return <Layout {...props} menu={CustomMenu} appBar={CustomAppBar} />;
};

export const CustomLayout: React.FC<LayoutProps> = (props) => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    MixpanelService.trackPageView({ pathname, search });
  }, [pathname, search]);

  return (
    <PhoneCallsProvider>
      {/* Inside the provider so it can tell whether a call is in progress, and a
          sibling of the layout so an expiry notice cannot be unmounted by the
          page the user happens to be on. */}
      <SessionExpirationGuard />
      <AppErrorBoundary scope='This page'>
        <LayoutWithModals {...props} />
      </AppErrorBoundary>
    </PhoneCallsProvider>
  );
};
